import React from 'react'
import {NavHeadLinks} from '../../../components/modules/pannelli/HeadLink';
import {MenuMobile} from '../../../components/modules/pannelli/MenuMobile';
import {useThemes} from '../../../components/hooks/hooks-mongoDB/useThemes';
import artiXS from '../../components/images/artigianato/intestato/ArtigianatoUpW500.png';
import artiS from '../../components/images/artigianato/intestato/ArtigianatoUpW800.png';
import artiM from '../../components/images/artigianato/intestato/ArtigianatoUpW1200.png';
import artiL from '../../components/images/artigianato/intestato/ArtigianatoUpW1200.png';
import artiXL from '../../components/images/artigianato/intestato/ArtigianatoUpW1600.png';
import artiXXL from '../../components/images/artigianato/intestato/ArtigianatoUpW3500.png';
import './zona-artigianale.scss';


function ZonaArtigianale() {
    const {themes} = useThemes();
    return (
        <section>
            {<NavHeadLinks title={"Zona Artigianale"} picB={artiXS}  picS={artiS} picM={artiM} picL={artiL} picXL={artiXL} picXXL={artiXXL} />}
            {/* <Scheda cards={cards}/> */}
            <div className="accordion--map">
                <div className = "container--title">
                    <h1 className = "title__top">  </h1> 
                </div>
            </div>
            <MenuMobile temi={themes}/>
            <div className="arti-container">
                <div className="arti-card">
                    <h1>🚧 Lavori in corso</h1>
                    <p>
                    Questa pagina è attualmente in costruzione.
                    Torna più tardi per vedere gli aggiornamenti.
                    </p>
                </div>
            </div>
        </section>
    )
}
export default ZonaArtigianale;
